export const API_URL = import.meta.env.VITE_API_URL;
export const VITE_SHOW_STUB = import.meta.env.VITE_SHOW_STUB;
export const TEXT_START_END = 'с 1 сентября 2025 года';
export const YANDEX_METRIKA_ID = import.meta.env.VITE_YANDEX_METRIKA_ID